import { currentUser } from "@/App";

const API_BASE = process.env.REACT_APP_API_BASE;

const headers = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};

export const postPost = async (type, meta, dt) => {
  const endpoint = new URL(API_BASE + "/v2/post");
  const formData = new FormData();
  formData.append("owner_key", currentUser.key);
  formData.append("artist_key", currentUser.key);
  formData.append("type", type);
  formData.append("meta", JSON.stringify(meta));
  formData.append("live", dt || Math.floor(new Date().getTime() / 1000)); // go live scheduled time

  try {
    const response = await fetch(endpoint.toString(), {
      ...headers,
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error posting post:", error);
    throw error;
  }
};
